






import { Component, Vue } from 'vue-property-decorator';
import Sketch from '@arcgis/core/widgets/Sketch';

@Component
export default class EsriSketch extends Vue {

    // subscribe to actions from vuex
    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'sketchToggle') {
            this.sketchToggle();
        }
    });

    public sketchWidget: __esri.Sketch | null  = null;

    public sketchToggle() {
        if (!this.sketchWidget) {
            this.sketchWidget = new Sketch({
                layer: this.$store.state.sketchLayer,
                view: this.$store.state.mapView,
                // border-radius
            });
            this.$store.state.mapView.ui.add(this.sketchWidget, 'top-right');
            // @ts-ignore
            this.sketchWidget.container.style = 'border-radius: 5px';
            this.sketchWidget.on('create', (event: any) => {
                if (event.state === 'complete') {
                    console.log(this.sketchWidget);
                    if (['polygon', 'circle', 'rectangle'].includes(event.tool)) {
                        event.graphic.symbol.outline.color = [102, 204, 255];
                    }
                    if (['polyline'].includes(event.tool)) {
                        event.graphic.symbol.color = [102, 204, 255];
                    }
                    if (['point'].includes(event.tool)) {
                        event.graphic.symbol.color = [102, 204, 255, 0.5];
                        event.graphic.symbol.outline.color = [102, 204, 255];
                    }
                }
            });
        } else {
            this.sketchWidget.destroy();
            this.sketchWidget = null;
        }
    }

    public mounted() {
        console.log('EsriSketch: mounted()');
    }

    public beforeDestroy() {
        this.unsubscribe();
    }
}

